import classNames from 'classnames';
import React from 'react';
import styles from './CenteredLayout.scss';

interface ICenteredLayoutProps {
  children: React.ReactNode;
  header?: React.ReactNode;
  className?: string;
  headerClassName?: string;
}

const CenteredLayout: React.FC<ICenteredLayoutProps> = ({
  children,
  className,
}) => <div className={classNames(styles.centered, className)}>{children}</div>;

export default CenteredLayout;
